var _g;

var _excluded = ["title", "titleId"];

function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }

function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }

import * as React from "react";

function SvgDeleteIcon(_ref, svgRef) {
  var title = _ref.title,
      titleId = _ref.titleId,
      props = _objectWithoutProperties(_ref, _excluded);

  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    width: 20.015,
    height: 20.204,
    viewBox: "0 0 20.015 20.204",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    id: "delete",
    transform: "matrix(1, 0.017, -0.017, 1, 22.433, 22.742)"
  }, /*#__PURE__*/React.createElement("g", {
    id: "noun_Delete_1640155",
    transform: "translate(-22.76 -22.442)"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Group_24",
    "data-name": "Group 24"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Group_15",
    "data-name": "Group 15",
    transform: "translate(2.832 5.033)"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Group_14",
    "data-name": "Group 14"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Path_55",
    "data-name": "Path 55",
    d: "M238.1,334.511v12.532a.723.723,0,0,1,0,.074c0-.005,0,.071-.005.071s.02-.118,0-.034-.042.147-.057.221.015-.053.02-.045-.017.042-.02.047c-.02.042-.04.081-.063.121s-.037.058-.055.087c-.03.05.027-.042.027-.039a.463.463,0,0,1-.042.053c-.023.026-.045.05-.067.074s-.093.105-.048.047.008-.005-.015.011-.027.018-.04.029a.951.951,0,0,1-.085.053l-.06.031c-.035.018-.038,0,0,0s.033-.013,0,0-.042.016-.062.021c-.038.011-.075.021-.115.029a.155.155,0,0,0-.05.01s.1-.008.048-.008-.083.005-.123.005H226.463c-.02,0-.133-.013-.053,0s-.043-.011-.068-.016-.075-.021-.113-.034c-.11-.037.058.034-.02-.005l-.088-.047a.573.573,0,0,1-.082-.055.536.536,0,0,1-.053-.039c0,.005.083.074.025.018s-.1-.113-.15-.158.037.039.027.039-.025-.037-.027-.042a1.1,1.1,0,0,1-.068-.118,1.016,1.016,0,0,0-.045-.092c-.027-.053.023.045.018.045s-.015-.045-.018-.05c-.012-.039-.022-.079-.033-.118s-.018-.147-.015-.071,0-.053,0-.074V334.508a.518.518,0,0,0-.5-.525.523.523,0,0,0-.5.525v12.521a1.979,1.979,0,0,0,.783,1.576,2.274,2.274,0,0,0,1.5.344h10.261a1.831,1.831,0,0,0,1.21-.447,1.959,1.959,0,0,0,.655-1.479c0-.323,0-.643,0-.967V334.508a.518.518,0,0,0-.5-.525.528.528,0,0,0-.505.528Z",
    transform: "translate(-224.7 -333.982)",
    fill: "#d30049"
  }))), /*#__PURE__*/React.createElement("g", {
    id: "Group_17",
    "data-name": "Group 17",
    transform: "translate(0 2.837)"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Group_16",
    "data-name": "Group 16"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Path_56",
    "data-name": "Path 56",
    d: "M136.377,228H117.389a.526.526,0,0,0,0,1.051h18.985a.526.526,0,0,0,0-1.051Z",
    transform: "translate(-116.882 -228)",
    fill: "#d30049"
  }))), /*#__PURE__*/React.createElement("g", {
    id: "Group_19",
    "data-name": "Group 19",
    transform: "translate(5.366)"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Group_18",
    "data-name": "Group 18"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Path_57",
    "data-name": "Path 57",
    d: "M336.018,123.356v-1.912c0-.05,0-.1,0-.147,0-.008.005-.037,0-.039.01.008-.032.129,0,.034a.558.558,0,0,0,.018-.068c.005.011-.06.11-.011.029.013-.021.024-.042.037-.06.037-.066-.018.008-.018.021,0-.016.052-.055.063-.066.092-.087-.071.037.037-.029.021-.013.042-.026.063-.037s.089-.029.021-.013.053-.01.076-.018c.089-.026-.016.008-.031,0a.356.356,0,0,0,.074,0h4.773c.617,0,1.235-.013,1.849,0-.081,0,.084,0,.053,0,.068,0-.1-.032-.037,0a.269.269,0,0,0,.066.018c.053.005-.047-.01-.047-.024l.113.066c-.039.013-.079-.076-.031-.021l.034.034c.026.029.016.016-.031-.042,0,0,.071.113.068.113s-.039-.129-.016-.032c.005.021.013.045.018.066a.436.436,0,0,1,.013.068c-.008,0-.005-.11-.008-.053,0,.018,0,.039,0,.058,0,.152,0,.3,0,.454v1.6a.525.525,0,0,0,1.051,0v-1.266a2.606,2.606,0,0,0-.242-1.571A1.251,1.251,0,0,0,342.95,120h-6.133a3.637,3.637,0,0,0-.793.039,1.363,1.363,0,0,0-1.053,1.224c-.008.142,0,.286,0,.431v1.668a.53.53,0,0,0,.525.525.539.539,0,0,0,.523-.528Z",
    transform: "translate(-334.966 -119.994)",
    fill: "#d30049"
  }))), /*#__PURE__*/React.createElement("g", {
    id: "Group_21",
    "data-name": "Group 21",
    transform: "translate(7.274 5.256)"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Group_20",
    "data-name": "Group 20"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Path_58",
    "data-name": "Path 58",
    d: "M404.427,334.608v9.248c0,.425-.011.851,0,1.277v.018a.53.53,0,0,0,.525.525.536.536,0,0,0,.525-.525V335.9c0-.426.01-.851,0-1.277v-.018a.525.525,0,1,0-1.051,0Z",
    transform: "translate(-404.422 -334.082)",
    fill: "#d30049"
  }))), /*#__PURE__*/React.createElement("g", {
    id: "Group_23",
    "data-name": "Group 23",
    transform: "translate(11.724 5.256)"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Group_22",
    "data-name": "Group 22"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Path_59",
    "data-name": "Path 59",
    d: "M580.327,334.608v9.248c0,.425-.01.851,0,1.277v.018a.53.53,0,0,0,.525.525.536.536,0,0,0,.525-.525V335.9c0-.426.01-.851,0-1.277v-.018a.525.525,0,0,0-1.051,0Z",
    transform: "translate(-580.322 -334.082)",
    fill: "#d30049"
  }))))))));
}

var ForwardRef = /*#__PURE__*/React.forwardRef(SvgDeleteIcon);
export default __webpack_public_path__ + "static/media/deleteIcon.fddcec9b.svg";
export { ForwardRef as ReactComponent };